import WsService from "services/WsService";
import InboundRedemptionFollowUp from "domain/Transaction/inbound/InboundRedemptionFollowUp";
import UserSessionService from "../../UserSessionService";
import BasicAuthGenerator from "../../../utils/BasicAuthGenerator";
import InboundRedemptionFollowUpCapturedDocument
    from "../../../domain/Transaction/inbound/InboundRedemptionFollowUpCapturedDocument";

const ENDPOINT_BASE = '/transactions/inbound/redemption/follow-up'

export default class InboundFollowUpService {

    static retrieveByToken(token) {
        let endpoint = ENDPOINT_BASE + "?token=" + token;

        let registrationHeaders = UserSessionService.retrieveRegisteringHeaders();

        let headers = {
            "Authorization": BasicAuthGenerator.create(registrationHeaders["registering-partner-username"], registrationHeaders["registering-partner-password"]),
            'registering-partner-id': registrationHeaders["registering-partner-id"],
            'registering-channel-id': registrationHeaders["registering-channel-id"]
        };

        return WsService.getWithHeaders(endpoint, {}, 200, headers).then(
            response => {
                return new InboundRedemptionFollowUp(response)
            },
            response => {
                return response;
            }
        );
    }

    static captureRequirements(followUpId, submissionObject) {

        let registrationHeaders = UserSessionService.retrieveRegisteringHeaders();

        let headers = {
            "Authorization": BasicAuthGenerator.create(registrationHeaders["registering-partner-username"], registrationHeaders["registering-partner-password"]),
            'registering-partner-id': registrationHeaders["registering-partner-id"],
            'registering-channel-id': registrationHeaders["registering-channel-id"]
        };

        let endpoint = ENDPOINT_BASE + "/" + followUpId + "/capture";
        let body = {
            'captured-documents': [],
            'signed-reporting-declaration': submissionObject.signedDeclaration,
            'reporting-declaration-version': submissionObject.declarationVersion
        }
        submissionObject.capturedDocuments.forEach((document) => {
            body['captured-documents'].push(InboundRedemptionFollowUpCapturedDocument.toJson(document))
        })
        return WsService.postWithHeaders(endpoint, body, 200, headers).then(
            response => {
                return new InboundRedemptionFollowUp(response);
            },
            response => {
                return response;
            }
        )
    }
}